import { useCallback, useEffect, useReducer } from 'react';

import handleQueries, { ActionCallbacks } from '../business/LoginPopupMultiple.handleQueries';
import reducer, {
  ActionType,
  getInitialState,
  LoginStep,
  State,
} from '../business/LoginPopupMultiple.reducer';

interface Actions {
  stepForward: () => void;
  stepBack: () => void;
}

type Props = ActionCallbacks;

function useLoginPopupMultipleMethods(props: Props): [State, Actions] {
  const { onClose, onSubmitCode, onClearInput } = props;

  const [state, dispatch] = useReducer(reducer, getInitialState());

  useEffect(
    () => {
      handleQueries(state.queries, dispatch, { onClose, onSubmitCode, onClearInput });
      /**
       * Queries need to be cleared so that it's safe to call handleQueries multiple times.
       * @todo (Mark) investigate this.
       */
    },
    // Intentionally only run this effect when state.queries changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state.queries]
  );

  const stepForward = useCallback(() => dispatch({ type: ActionType.AdvanceStep }), []);

  const stepBack = useCallback(() => dispatch({ type: ActionType.RegressStep }), []);

  return [
    state,
    {
      stepForward,
      stepBack,
    },
  ];
}

export default useLoginPopupMultipleMethods;
export { ActionType, getInitialState, LoginStep, reducer };
export type { Actions, Props };
